import { gql } from "@apollo/client";

export const QUERY_GET_CONTENT_INFO = gql`
  query QUERY_GET_CONTENT_INFO {
    mediaGroup {
      id
      description
      created_at
      imageUrl
      name
      updated_at
      processToMediaGroups {
        id
        created_at
        processId
        updated_at
        mediaGroupId
        process {
          id
          nameKey
          processName
          descript
          userToProcesses_aggregate {
            aggregate {
              count
            }
          }
        }
      }
      mediaCards {
        id
        episode
        description
        duration
        created_at
        linkUrl
        season
        title
        updated_at
        mediaCardToMediaTags {
          id
          enMediaTag {
            comment
            value
          }
        }
      }
    }
  }
`